/**
 * File: effortFormUtils.ts
 * Path: apps/admin/src/shared/utils/effortFormUtils.ts
 * Description: Checks for the add-cost, add-time and stop-timer forms: a rand
 * amount typed as text, a day, and a whole number of minutes. Pure.
 */

import { MAX_ENTRY_MINUTES, toCents } from "@idk/config";

/** "R1 250,50", "1250.5" or "1 250" → cents, or null when it isn't an amount. */
export const parseRand = (text: string): number | null => {
  const cleaned = text.replace(/[R\s]/gi, "").replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const cents = toCents(Number(cleaned));
  return cents >= 1 && cents <= 100_000_000 ? cents : null;
};

/** A day typed or picked as YYYY-MM-DD. */
export const isIsoDay = (value: string): boolean => /^\d{4}-\d{2}-\d{2}$/.test(value);

/** A whole number of minutes an entry may hold. */
export const isEntryMinutes = (value: number): boolean =>
  Number.isInteger(value) && value >= 1 && value <= MAX_ENTRY_MINUTES;
